import React, { useCallback, useMemo } from 'react';
import TimePickerV2 from '@/components/TimePicker/TimePickerV2';
import appointmentStyles from '@/ctComponents/AppointmentTable/AppointmentTable.module.css';
import AutobookTimeDateSelector from '@/screens/Autobook/AutobookTimeDateSelector';

const FIELD_PX = '23.8%';
const WINDOW_FIELD_MIN_PX = '23.8%';

const inputStyle = {
  width: '100%',
  maxWidth: '100%',
  minWidth: 0,
  boxSizing: 'border-box',
};

const LIVE_UNLOAD_SUBTITLE =
  "Delivery time + unloading time + drive to port = target booking time Smart Turn searches within the autobook window, then continues up to the rule's global maximum days after the window";
const LIVE_UNLOAD_SUBTITLE_2 =
  'Select hours, days, dates, or terminals where AutoBook should NOT schedule appointments.';

export const AutobookRuleStepLiveUnload = ({
  unloadTime,
  setUnloadTime,
  driveToPortMin,
  setDriveToPortMin,
  autobookBackwardWindowHour,
  setAutobookBackwardWindowHour,
  autobookForwardWindowHour,
  setAutobookForwardWindowHour,
  rulePreferences,
  onRulePreferencesChange,
  preferencesSyncKey,
}) => {
  const autobookModeOff = useMemo(() => ({ status: false }), []);
  const noopHistory = useCallback(() => {}, []);

  return (
    <section className="box-border flex w-full min-w-0 max-w-full flex-col rounded-lg border border-solid border-[#e8e8e8] bg-white p-4">
      <h2 className="m-0 shrink-0 text-left text-base font-bold leading-snug text-[#131517]">
        Live Unload Appointment Logic
      </h2>
      <p className="m-0 mt-2 max-w-[920px] shrink-0 text-left text-sm leading-relaxed text-[#717784]">
        {LIVE_UNLOAD_SUBTITLE}
      </p>

      <div className="mt-5 flex w-full min-w-0 max-w-full flex-row flex-wrap items-start gap-4">
        <div
          className={`${appointmentStyles.LicenseContainer} min-w-0 shrink-0`}
          style={{ width: FIELD_PX, maxWidth: FIELD_PX }}>
          <span className="font-averta mb-2 block text-sm font-bold text-primary-text">
            Unloading Time (Hrs)
          </span>
          <TimePickerV2
            value={unloadTime}
            inputHeightClassName="h-12 text-sm pr-8"
            onChange={(value) => setUnloadTime(value ?? '')}
          />
        </div>

        <div
          className={`${appointmentStyles.LicenseContainer} min-w-0 shrink-0`}
          style={{ width: FIELD_PX, maxWidth: FIELD_PX }}>
          <span className="font-averta mb-2 block text-sm font-bold text-primary-text">
            Drive to Port (Min)
          </span>
          <input
            type="number"
            className={appointmentStyles.LicenseInput}
            value={driveToPortMin}
            onChange={(e) => setDriveToPortMin(e.target.value)}
            placeholder="Minutes"
            min={0}
            style={inputStyle}
          />
        </div>

        <div
          className={`${appointmentStyles.LicenseContainer} min-w-0 shrink-0`}
          style={{
            width: WINDOW_FIELD_MIN_PX,
            maxWidth: WINDOW_FIELD_MIN_PX,
          }}>
          <span className="font-averta mb-2 block text-sm font-bold text-primary-text">
            Before Target Return (Min)
          </span>
          <input
            type="number"
            className={appointmentStyles.LicenseInput}
            value={autobookBackwardWindowHour}
            onChange={(e) => setAutobookBackwardWindowHour(e.target.value)}
            placeholder="Hours"
            min={0}
            style={inputStyle}
          />
        </div>

        <div
          className={`${appointmentStyles.LicenseContainer} min-w-0 shrink-0`}
          style={{
            width: WINDOW_FIELD_MIN_PX,
            maxWidth: WINDOW_FIELD_MIN_PX,
          }}>
          <span className="font-averta mb-2 block text-sm font-bold text-primary-text">
            After Target Return (Min)
          </span>
          <input
            type="number"
            className={appointmentStyles.LicenseInput}
            value={autobookForwardWindowHour}
            onChange={(e) => setAutobookForwardWindowHour(e.target.value)}
            placeholder="Hours"
            min={0}
            style={inputStyle}
          />
        </div>
      </div>

      <div className="mt-6 w-full min-w-0 max-w-full border-0 border-t border-solid border-[#e8e8e8] pt-6">
        <p className="m-0 mt-2 max-w-[920px] shrink-0 text-left text-sm font-bold leading-relaxed text-[#717784]">
          {LIVE_UNLOAD_SUBTITLE_2}
        </p>
        <AutobookTimeDateSelector
          persistToContainer={false}
          settings={rulePreferences}
          onPreferencesChange={onRulePreferencesChange}
          preferencesSyncKey={preferencesSyncKey}
          hideAddRangePrioritySelect
          hidePreferencesHeader
          rulesWeekdayDesign
          rulesTerminalDesign
          lfdDate={null}
          autobookMode={autobookModeOff}
          setHistoryList={noopHistory}
        />
      </div>
    </section>
  );
};
